var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeslash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.205,
    height: 15.49,
    viewBox: "0 0 16.205 15.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10660",
    "data-name": "Group 10660",
    transform: "translate(-13.813 -13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_preview_1389979",
    transform: "translate(11.5 -3.766)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1828",
    "data-name": "Group 1828",
    transform: "translate(2.5 19.765)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1825",
    "data-name": "Group 1825",
    transform: "translate(3.844 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M29.639,27.944a4.089,4.089,0,1,1,4.088-4.09A4.094,4.094,0,0,1,29.639,27.944Zm0-7.495a3.405,3.405,0,1,0,3.4,3.4A3.408,3.408,0,0,0,29.639,20.449Z",
    transform: "translate(-25.552 -19.766)",
    fill: "#263658",
    stroke: "#263658",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1826",
    "data-name": "Group 1826",
    transform: "translate(5.188 1.345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M34.3,30.576h-.683a2.746,2.746,0,0,1,2.743-2.743v.683A2.062,2.062,0,0,0,34.3,30.576Z",
    transform: "translate(-33.614 -27.833)",
    fill: "#263658",
    stroke: "#263658",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1827",
    "data-name": "Group 1827",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M10.7,29.848c-4.383,0-7.9-4.64-8.044-4.837l-.152-.2.152-.2c.148-.2,3.66-4.837,8.044-4.837,4.4,0,7.4,4.66,7.529,4.859l.116.183-.116.183C18.1,25.188,15.1,29.848,10.7,29.848ZM3.362,24.806c.726.887,3.793,4.357,7.333,4.357s6.231-3.508,6.827-4.357c-.6-.85-3.275-4.358-6.827-4.358S4.088,23.918,3.362,24.806Z",
    transform: "translate(-2.5 -19.765)",
    fill: "#263658",
    stroke: "#263658",
    strokeWidth: 0.3
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2354",
    "data-name": "Rectangle 2354",
    transform: "matrix(0.819, 0.574, -0.574, 0.819, 26.324, 13)",
    fill: "#263658",
    stroke: "#263658",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.3,
    height: 18,
    rx: 0.65,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 0.3,
    height: 17,
    rx: 0.15,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeslash);
export default __webpack_public_path__ + "static/media/eyeslash.cbc9c5e3bad887e13e8591f897e7ea8c.svg";
export { ForwardRef as ReactComponent };